import type { Container } from '@sbclite/core'

interface CreatedProfile {
  readonly success: boolean
  readonly data: { readonly id: string }
}

export async function createAndAssignExistingEngineConfiguration(
  input: Container.ProfileCreateInput,
  containerId: string,
  strictMode: boolean,
  createProfile: (input: Container.ProfileCreateInput) => Promise<CreatedProfile>,
  assignProfile: (input: { readonly profileId: string; readonly containerId: string; readonly strictMode: boolean }) => Promise<unknown>,
): Promise<string> {
  const response = await createProfile(input)
  if (!response.success) throw new Error('Configuration was not saved')
  await assignProfile({ profileId: response.data.id, containerId, strictMode })
  return response.data.id
}
